/*
 * list of parameters
 * @param {facebook app id} appId
 * @param {method for authorized customer} apiAuthRequest
 */
var FacebookAuthorization = (function ($) {

    var _fbApiInit = new $.Deferred();
    var _fbApiInitXHR = _fbApiInit.promise();

    function FacebookAuthorization(options) {
        this.appId = options.appId;
        this.authCallback = options.authCallback;
        if (this.appId) {

            var _init = $.proxy(this._init, this);

            $.getScript(document.location.protocol + '//connect.facebook.net/en_US/all.js')
                .then(function() {
                    setTimeout(_init, 1000);
                });

            $(options.btnID).on('click', $.proxy(this._authorize, this));
        }
    }

    FacebookAuthorization.prototype =
    {
        _init: function () {
            FB.init({
                appId: this.appId,
                status: true,
                cookie: true,
                xfbml: true,
                version: 'v3.1'
            });

            FB.getLoginStatus(_fbApiInit.resolve);
        },
        _getCustomerInfo: function (response) {
            var settings = window.GlobalSettings || app.GlobalSettings;

            if (response && response.authResponse && response.authResponse.userID) {

                this.authCallback({
                    facebookUserID: response.authResponse.userID,
                    accessToken: response.authResponse.accessToken,
                    facebookCookieValue: document.cookie.replace(new RegExp('.*fbsr_' + settings.Fid + '='), '')
                        .replace(/;.*/, '')
                });
            }
        },
        _callFbLogin: function () {
            FB.login($.proxy(this._getCustomerInfo, this), { scope: 'email' });
        },
        _authorize: function (e) {
            e.preventDefault();
            _fbApiInitXHR.done($.proxy(this._callFbLogin, this));
        }
    }

    return FacebookAuthorization;

})(jQuery);